import AlertsPopup from "./alerts.popup";
import BasePopup from "./base.popup";
import DevicesPopup from "./devices.popup";
import FlagPopup from "./reports/flag.popup";
import SpeedingPopup from "./reports/speeding.popup";
import StoppingPopup from "./reports/stopping.popup";

export default class PopupStrategyFactory {
    create(type: string, feature: any): BasePopup | undefined {
        switch (type) {
            case 'alert':
                return new AlertsPopup(feature)
            case 'device':
                return new DevicesPopup(feature)
            case 'stop':
                return new StoppingPopup(feature)
            case 'speeding':
                return new SpeedingPopup(feature)
            case 'flag':
                return new FlagPopup(feature)
            // case 'geofence':
            //     return null
            default:
                break
        }
    }
}